import handler from 'api/handler'

const prefix = '/admin/resume'

const methods = {
  create: args => handler({ method: 'post', url: `${prefix}/create`, args }),
  updateResumeApprovalStatus: args => handler({ method: 'put', url: `${prefix}/updateResumeApprovalStatus`, args }),
  fetchNewResumes: args => handler({ method: 'get', url: `${prefix}/fetchNewResumes`, args }),
}

export default methods
